const schemaLocale = {
    mixed: {
        required: "Este campo é necessário"
    },
    string: {
        isValidCardExpiration: "Cartão de crédito inválido"
    }
}

export default schemaLocale